import { render, staticRenderFns } from "./ExcelExportVenta.vue?vue&type=template&id=112dc72f"
import script from "./ExcelExportVenta.vue?vue&type=script&lang=js"
export * from "./ExcelExportVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports